import { Guid } from "@/types"

export interface IGetAssetProductDto {
    id: Guid
    code: string
    description: string
}

export default class AssetProduct {
    id: Guid
    code: string
    description: string

    constructor(dto: IGetAssetProductDto) {
        this.id = dto.id
        this.code = dto.code
        this.description = dto.description
    }
}
